import React from "react";
import { SvgTrashIcon, SvgUploadTxt } from "../../svg";
import { converFileToPeriodData } from '../utils';

class FileUploader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            files: [],
            uploadedFiles: [],
            isUploading: false,
        }
        this.uploadFiles = this.uploadFiles.bind(this)
    }

    componentDidMount() {
        var $form = $('.box');
        if (this.isAdvancedUpload()) {
            $form.addClass('has-advanced-upload');

            const dropZone = document.getElementById('box__dragndrop');
            const fileInput = document.getElementById('box__file');

            dropZone.addEventListener('click', () => {
                fileInput.click();
            });

            const onDragOver = (e) => {
                e.preventDefault();
                e.dataTransfer && (e.dataTransfer.dropEffect = 'copy');
                dropZone.classList.add('active');
            };
            const onDragLeave = (e) => {
                e.preventDefault();
                dropZone.classList.remove('active');
            };
            dropZone.addEventListener('dragenter',onDragOver);
            dropZone.addEventListener('dragover',onDragOver);
            dropZone.addEventListener('dragleave', onDragLeave);
            dropZone.addEventListener('dragend', onDragLeave);            

            dropZone.addEventListener('drop', (e) => {
                e.preventDefault();
                e.stopPropagation();
                dropZone.classList.remove('active');
                // reuse your existing handler which expects e.dataTransfer.files
                this.handleChange(e);
            });            

        }
    }

    addFilesContentToInfo(newFiles) {
        let allFilesWithContent = [];

        if (newFiles) {
            let allJpgFiles = newFiles.filter(item => item.errorMsg !== "");
            allJpgFiles.map((newFile) => {
                allFilesWithContent.push({ name: newFile.name, data: newFile.contents, type: newFile.file.type })
            })
        } else {
            let allJpgFiles = this.state.files.filter(item => item.errorMsg !== "");
            allJpgFiles.map((file) => {
                allFilesWithContent.push({ name: file.name, data: file.contents, type: file.file.type })
            })
        }
    }

    onDone(files) {
        this.setState({
            files: [
                ...this.state.files,
                ...files
            ]
        })
        { !this.props.uploadFiles && this.addFilesContentToInfo() }
    }

    handleChange(e) {
        let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        var allFiles = [];
        for (const file of files) {
            let reader = new FileReader();
            reader.onload = () => {
                let fileInfo = {
                    name: file.name,
                    type: file.name.split('.').pop(),
                    size: Math.round(file.size / 1000) + ' kB',
                    contents: reader.result,
                    file: file,
                };
            
                if (Math.round(file.size / 1000) > 15000){
                    return (
                        alert("Ekki var hægt að hlaða upp skjali (skjal má að hámarki vera 15MB).")
                    )
                }

                if (['txt','TXT'].includes(file.name.split('.').pop())) {
                    allFiles.push(fileInfo);
                }

                if (allFiles.length == files.length) {
                    this.onDone(allFiles)
                } else {
                    return (
                        alert("Þú hefur bætt við skjali á " + file.name.split('.').pop() + " formi.\n Skjalið þarf að vera á txt formi.")
                    )
                }
            }
            reader.readAsText(file);
        }
    }

    isAdvancedUpload() {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    };

    removeFile(file) {
        let newFiles = []
        this.state.files.map((f) => {
            if (f.contents !== file.contents) {
                newFiles.push(f)
            }
            return newFiles
        })
        this.setState({
            files: newFiles
        })
        { !this.props.uploadFiles && this.addFilesContentToInfo(newFiles) }
    }

    renderAddedFiles() {
        if (this.state.files.length > 0) {

            let allFiles = this.state.files.map((file) => {
                
                return (
                    <div className="file-container">
                        <div className="file-text" style={{display:"flex"}}>
                            <div title="Eyða" className="erase-btn" onClick={this.removeFile.bind(this, file)}>
                                <SvgTrashIcon style={{width:"16px"}}/>
                            </div>
                            <div className="file-name" style={{marginLeft: 10}}>{file.name}</div>
                        </div>
                    </div>
                )
                // if (file.errorMsg === '') {
                // }
            })
            return allFiles;
        }
    }

    renderUploadedFiles(){
        if (this.state.uploadedFiles.length > 0) {

            let allFiles = this.state.uploadedFiles.map((file) => {
                
                return (
                    <div className="success-container">
                        <div className="file-name">
                            <div>{file.file.name} hlaðið upp sem {file.name}</div>
                        </div>
                    </div>
                )
            })
        return <div className="uploaded-container"><div className="uploaded-title">Eftirfarandi skrám hefur verið hlaðið upp:</div>{allFiles}</div>;
        }
    }

    uploadFiles(e) {
        this.setState({
            isUploading: true
        })

        e.preventDefault();
        if (this.props.uploadConfirmed) {
            let allFiles = this.state.files.filter(item => item.errorMsg !== "").map(f => {
                let fileObj = {...f}
                fileObj.type = fileObj.name.split('.').pop()
                return fileObj
            });
            this.props.uploadConfirmed(allFiles);
        }
    }

    render() {
        return (<>
            <div className="add-files-container" style={{marginBottom: 20}}>
                <div className="files-added-container" style={{display:"flex"}}>
                    <form className="file-uploader box" style={{marginRight: 20}} method="post" action="" encType="multipart/form-data" >
                        <fieldset disabled={this.props.disabled} >
                            <div className="box__input">
                                <input
                                    id="box__file"
                                    className="box__file"
                                    type="file"
                                    onChange={this.handleChange.bind(this)}
                                    multiple={this.props.multiple} />
                                <div id="box__dragndrop" className="box__dragndrop">
                                    <SvgUploadTxt />
                                    <label htmlFor="file"><strong>Smelltu hér til að sækja skjal</strong><span > eða dragðu það hingað</span>.</label>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <div className="files-container" style={{display:"flex"}}>
                        {this.renderAddedFiles()}
                        { this.state.files.length > 0 &&
                            <div className="button-container" style={{alignSelf:"end"}}>
                                <button className="btn btn-primary" onClick={this.uploadFiles}>{this.state.isUploading ? 'Hleður upp...' : 'Hlaða upp'}</button>
                            </div>
                        }
                        {this.renderUploadedFiles()}
                    </div>
                </div>

                { this.state.uploadError && <div>{this.state.uploadError}</div>}
            </div>
        </>
        );
    }
}

FileUploader.defaultProps = {
    useOriginalFilename: true
}

export default FileUploader